module.exports = __webpack_public_path__ + "media/1x1/cg-8373836c.svg";